module.exports = __webpack_public_path__ + "static/media/GOOGLE_POLISH_MALE2.5fa4f594.mp3";